export type Unit =
  | "seconds"
  | "spots"
  | "audience"
  | "grp"
  | "spots_and_seconds";

export function isAuditelUnit(unit: Unit): boolean {
  return unit == "audience" || unit == "grp";
}
